import React, { useState, useEffect } from 'react'
import { DashboardLayout, Toaster, Dropdown, Button, MultiFilters, GeneralTable, SubmenuTooltip, MoreButton } from 'components'
import 'assets/scss/billingPortal/modules/mobileLicenseKey.scss';
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { useCustomSelector } from 'hooks';
import { isArrayNotEmpty, isNotNullUndefined, isObjectEmpty, getTotalCountFromHeader } from 'functions';
import { useReportTableColumns } from './hooks/useReportTableColumns';
import useMobileLicenseKey from 'dataflow/billingPortal/actions/useMobileLicenseKey.actions';
import useDropdownLists from '../accountControl/hooks/useDropdownLists';
import ic_export from "assets/images/ic_export.svg";
import { statusOptions } from './constants/constant';

export default function MobileLicenseKeyReport() {

    const [pageTitle] = useState("Product Name")
    const [packageName, setpackageName] = useState();
    const [isLicenseReport, setisLicenseReport] = useState(false);
    const [exportFilterOptions, setexportFilterOptions] = useState({});

    const { userPermissions } = useCustomSelector("userManagementReducers");

    const {
        comIdList
    } = useDropdownLists();

    let { 
        packageNameList, getLicenseReport_requesting, licenseReport, licenseReportHeaders
    } = useCustomSelector("mobileLicenseKey");

    const { setLicensePackagePackageName, getPackageList, getLicenseReport, exportLicenseReport } = useMobileLicenseKey();

    useEffect(() => {
        getPackageList();
    }, []);

    const columns = useReportTableColumns()

    function searchLicenseReport() {
        setLicensePackagePackageName(packageName)
        setisLicenseReport(true)
    }

    let mainDisplay = (
        <div className='mobile-license-key__content'>
            <div className={'mobile-license-key__content-body'}>
                <div className={"row"}>
                    <div className='col-12 col-lg-5 pb-4'>
                        <Dropdown
                            options={(isArrayNotEmpty(packageNameList))? packageNameList.map((obj) => {
                                let packageId = obj?.packageName? obj.packageName:"";
                                let packageName = obj?.packageName? obj?.packageName:"";
    
                                return {
                                    label: packageName,
                                    value: packageId
                                };
                            }):""}
                            selectedValue_default={packageName}
                            onChange={(value, label) => {
                                setpackageName(value)
                            }}
                            onEnterKeyPressed={searchLicenseReport}
                            label={pageTitle}
                            isLabelLegend isSearchable isClearable
                        />
                    </div>
                    <div className='col-12 col-lg-2 pt-0 pt-lg-4'>
                        <Button
                            className={"grab-button__input float-right float-lg-none"}
                            isLoading={getLicenseReport_requesting}
                            isDisabled={getLicenseReport_requesting}
                            handleOnClick={searchLicenseReport}
                        >
                            Search
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )

    let licenseReportDisplay = (
        <GeneralTable
            className={"mobile-license-key__main-table"}
            columns={columns}
            data={licenseReport}

            getTableData={getLicenseReport}

            outerTableHeader={(outerTableHeader_props) => {
                const { 
                    filterOptions, setFilterOptions
                } = outerTableHeader_props;

                return (
                    <div className={"table__headers"}>
                        {/* Top Section */}
                        <div className={"headers__top-section d-flex justify-content-between align-items-center mt-4 mb-4"}>
                            {/* Title */}
                            <div className={"headers__title tableHeaderTitle "}>
                                {pageTitle} - {packageName}
                            </div>

                            <SubmenuTooltip
                                menuItems={[
                                    {
                                        icon: ic_export,
                                        label: "Export",
                                        isDisabled: !(userPermissions?.Internal_MobileLicense_Export),
                                        onClick: () => {
                                            exportLicenseReport(packageName, exportFilterOptions)
                                        },
                                    }
                                ]}
                            >
                                <MoreButton
                                    className={"action__more-actions"}
                                    iconClassName={"more-actions__icon"}
                                />
                            </SubmenuTooltip>
                        </div>

                        {/* Bottom Section */}
                        <div className={"headers__bottom-section"}>
                            <MultiFilters
                                defaultFilterOption={{
                                    label: "COM ID", 
                                    propertyName: "comId",
                                    placeholder: "COM ID",
                                    options: comIdList,
                                    inputType: "dropdown",
                                    isInputDigitOnly: true
                                }}
                                filterOptions={[
                                    {
                                        label: "COM ID", 
                                        propertyName: "comId",
                                        placeholder: "COM ID",
                                        options: comIdList,
                                        inputType: "dropdown",
                                        isInputDigitOnly: true
                                    },
                                    {
                                        label: "Trial Status", 
                                        propertyName: "isTrial",
                                        placeholder: "Trial Status",
                                        options: statusOptions,
                                        inputType: "dropdown"
                                    },
                                    {
                                        label: "Deleted Date", 
                                        propertyName: "deletedDate",
                                        placeholder: "Deleted Date",
                                        inputType: "date"
                                    },
                                    {
                                        label: "Trial Expired", 
                                        propertyName: "isTrialExpired",
                                        placeholder: "Trial Expired",
                                        options: statusOptions,
                                        inputType: "dropdown"
                                    },
                                    {
                                        label: "License Source", 
                                        propertyName: "licenseSource",
                                        placeholder: "License Source",
                                        options: [
                                            { label: "Maxis", value: "Maxis"},
                                            { label: "Others", value: "Others"}
                                        ],
                                        inputType: "dropdown"
                                    }
                                ]}
                                dropdownPlaceholder={"Select Filter"}
                                onApplyFilter={(inputFilters) => {
                                    let filtered_options = isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters}
                                    setFilterOptions(filtered_options);
                                    setexportFilterOptions(filtered_options);
                                }}
                            />
                        </div>
                    </div>
                );
            }}
            
            isTableDataLoading={getLicenseReport_requesting}

            isUsingPagination
            totalRecords={getTotalCountFromHeader(licenseReportHeaders)}

            isExpanderRequired isRowExpanderColumnFirst
            isColumnResizeable
            isTableOddRowsDarken
        />
    )

    return (
        <DashboardLayout
            headerTitle={"Product License Key Report"}

            bodyClassName={"mobile-license-key"}
            isHeaderCloseIconVisible={isLicenseReport}
            updateParentState_visiblity={isLicenseReport? setisLicenseReport:null}
            body={isLicenseReport? licenseReportDisplay:mainDisplay}
        />
    )
}